import type { FaireProductEntity } from "../../entity_types/product";

export const p_u5bddnlw55: FaireProductEntity = {
  token: "p_u5bddnlw55",
  type: "product",
  name: "Variety Pack of Chips - 5.6oz Cans (Case of 8)",
  brandToken: "b_4lp7ouz3yu",
  brandName: "The Good Crisp Company",
  imageUrl:
    "https://cdn.faire.com/fastly/137cca750d037011614527d3c1a7beb7391c071f9bd84fbefc479043bcbe77f4.png",
  galleryImageUrls: [],
  priceDollars: 27.49,
  description:
    "Snackers rejoice. Our Variety Pack is literally (okay...not literally) the best thing you could do for yourself and family, at least when it comes to chips. Why choose just one delicious recipe when you can have the lot? Enjoy the classics, the salty, the spicy, and the cheesy in one easy to order package.  ",
  tags: [],
  msrpDollars: 54.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:13.031Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
